import React from 'react'
import PropTypes from 'prop-types'

import { Field } from 'formik'
import FormError from './FormError'

const FieldBase = ({ 
  name, label, floatingLabelFixed, errorText, ...other 
}) => {

  return (
    <div>
      <Field
        name={name}
        label={label}
        {...other} 
      />
      <FormError text={errorText} />
    </div>
  )
}

FieldBase.displayName = 'FieldBase'    

FieldBase.propTypes = {
  label: PropTypes.string,
  errorText: PropTypes.string,
  name: PropTypes.string.isRequired,
  floatingLabelFixed: PropTypes.bool,
}

export default FieldBase



// WEBPACK FOOTER //
// ./src/components/atoms/FieldBase.js